import { ThunkDispatch } from 'redux-thunk';
import {
  reloadUserpilot,
  sendUserpilotTracking,
  sendUserpilotTrigger,
  sendUserpilotIdentify,
} from '../../ReduxStorage/Userpilot/dispatchers';
import { ReduxAction } from '../../ReduxStorage/actions';
import { ReduxState } from '../../ReduxStorage/state';

class Userpilot {
  reload = () => (
    dispatch: ThunkDispatch<ReduxState, void, ReduxAction>
  ): void => {
    dispatch(reloadUserpilot());
  };

  track = (eventName: string, meta?: Record<string, unknown>) => (
    dispatch: ThunkDispatch<ReduxState, void, ReduxAction>
  ): void => {
    dispatch(sendUserpilotTracking(eventName, meta));
  };

  identify = () => (
    dispatch: ThunkDispatch<ReduxState, void, ReduxAction>
  ): void => {
    dispatch(sendUserpilotIdentify());
  };

  // Commented anonymous() out for now, because we don't want to use
  // window.userpilot.anonymous() because of userpilot user limit
  // anonymous = () => (
  //   dispatch: ThunkDispatch<ReduxState, void, ReduxAction>
  // ): void => {
  //   dispatch(sendUserpilotAnonymous());
  // };

  trigger = (checkListId: string) => (
    dispatch: ThunkDispatch<ReduxState, void, ReduxAction>
  ): void => {
    dispatch(sendUserpilotTrigger(checkListId));
  };
}

export const userpilot = new Userpilot();
